// extracted by mini-css-extract-plugin
export default {"news-modal-content__modal":"news-modal-content__modal__9F85U","news-modal-content__modal-main":"news-modal-content__modal-main__2vET3"};